module.exports = __webpack_public_path__ + "static/tsn-grid-2-63097a9c7b1df2efca70f65100b38e4f.jpg";